module.exports = __webpack_public_path__ + "img/login_left_img.9c24bdc8.png";